var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6848 18.885L17.2998 30.255V0H14.2998V30.255L2.9148 18.885L0.799805 21L15.7998 36L30.7998 21L28.6848 18.885Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownArrow);
export default __webpack_public_path__ + "static/media/ic-down-arrow.45a2e0b920a9b7a2f77f55894c6744ad.svg";
export { ForwardRef as ReactComponent };